<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-title>{{ 'market.search' | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-button
        (click)="cancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

@if (countries(); as countries) {
  <ion-content class="ion-padding-horizontal-0">
    <form [formGroup]="searchForm">
      <ion-grid>
        <ion-row>
          <ion-col
            size="12"
            sizeMd="6"
          >
            <div class="block-content-round">
              <p class="subtitle">{{ 'freight.detail.origin' | translate }}</p>
              <div class="ion-padding-top">
                <ion-select
                  label="País"
                  interface="popover"
                  label-placement="floating"
                  fill="outline"
                  mode="md"
                  multiple="false"
                  name="fromCountry"
                  formControlName="fromCountry"
                  (ionChange)="handleChangeFromCountry($event)"
                >
                  @for (country of countries; track country.isoCode) {
                    <ion-select-option [value]="country.isoCode">{{ country.name }}</ion-select-option>
                  }
                </ion-select>
              </div>
              <div class="ion-padding-top">
                <ion-select
                  label="Provincia"
                  interface="popover"
                  label-placement="floating"
                  fill="outline"
                  mode="md"
                  multiple="false"
                  name="fromState"
                  formControlName="fromState"
                >
                  @for (state of fromStates.value(); track state.stateCode) {
                    <ion-select-option [value]="state.stateCode">
                      {{ state.state + '(' + state.stateCode + ')' }}
                    </ion-select-option>
                  }
                </ion-select>
              </div>
            </div>
          </ion-col>
          <ion-col
            size="12"
            sizeMd="6"
          >
            <div class="block-content-round">
              <p class="subtitle">{{ 'freight.detail.destination' | translate }}</p>
              <div class="ion-padding-top">
                <ion-select
                  label="País"
                  interface="popover"
                  label-placement="floating"
                  fill="outline"
                  mode="md"
                  multiple="false"
                  name="toCountry"
                  formControlName="toCountry"
                  (ionChange)="handleChangeToCountry($event)"
                >
                  @for (country of countries; track country.isoCode) {
                    <ion-select-option [value]="country.isoCode">{{ country.name }}</ion-select-option>
                  }
                </ion-select>
              </div>
              <div class="ion-padding-top">
                <ion-select
                  label="Provincia"
                  interface="popover"
                  label-placement="floating"
                  fill="outline"
                  mode="md"
                  multiple="false"
                  name="toState"
                  formControlName="toState"
                >
                  @for (state of toStates.value(); track state.stateCode) {
                    <ion-select-option [value]="state.stateCode">
                      {{ state.state + '(' + state.stateCode + ')' }}
                    </ion-select-option>
                  }
                </ion-select>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </ion-content>
}

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            fill="solid"
          >
            <ion-icon
              src="../assets/material-symbols/search_24dp.svg"
              slot="start"
            ></ion-icon>
            {{ 'general.search' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
